import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20live%20streaming%20platform%20abstract%20background%20with%20colorful%20gradient%20light%20beams%20and%20dynamic%20energy%20waves%2C%20modern%20digital%20entertainment%20aesthetic%2C%20warm%20coral%20and%20golden%20tones%2C%20smooth%20bokeh%20effect%2C%20clean%20futuristic%20atmosphere&width=1920&height=1080&seq=hero-bg-mogu&orientation=landscape"
          alt="蘑菇tv直播平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-0">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-8">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-sm text-background-50/90 font-medium">10,000+ 主播正在直播中</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight max-w-3xl">
            发现精彩，<span className="text-accent-400">点燃热爱</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-background-200/90 max-w-2xl leading-relaxed">
            蘑菇tv汇聚海量高清直播与短视频内容，覆盖游戏、娱乐、生活、体育等多元领域。
            无论你想看<strong>精彩赛事</strong>还是寻找<strong>心仪主播</strong>，这里都有你想要的精彩。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-10">
            <a
              href="#"
              className="px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-line mr-2"></i>立即下载蘑菇tv
            </a>
            <Link
              to="/category/game"
              className="px-8 py-3.5 rounded-xl bg-background-50/15 backdrop-blur-sm text-background-50 font-medium text-base border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-play-circle-line mr-2"></i>浏览热门直播
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mt-16">
            {[
              { value: '5000万+', label: '日活用户' },
              { value: '10万+', label: '签约主播' },
              { value: '80万h+', label: '日均直播' },
              { value: '99.9%', label: '服务可用率' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
                <div className="text-sm text-background-300/80 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}